module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-recommendations.svg?44a41b90bfad40f8087305b47ef32a16";